import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createProvider = ( {data} : {data: IPostNewProvider | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/Providers/InsertProvider`, data);
};

type QueryFnType = typeof createProvider;

type UseCreateProviderOptions = {
  data: IPostNewProvider | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateProvider = ({ config }: UseCreateProviderOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Παρόχου.`, 500);
            console.error('Couldnt create new Provider', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllProviders"])
            addNotification("Δημιουργήθηκε Νέος Πάροχος.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createProvider,
    })
}